import { mallApi } from '../request'
import { apiPath } from '../api'

export const wechat = {
  getWechatConfig: () => mallApi.post(apiPath.getWechatConfig)
}
